import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatError } from "../lib/api";
import { AuthShell } from "./Login";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="password">New password</Label>
          <Input id="password" data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1.5" placeholder="At least 6 characters" />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <Button type="submit" data-testid="reset-submit" disabled={loading || !token} className="w-full bg-slate-900 hover:bg-slate-800 h-11">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reset password"}
        </Button>
        <p className="text-sm text-center text-slate-600"><Link to="/login" className="text-sky-600 hover:underline">Back to sign in</Link></p>
      </form>
    </AuthShell>
  );
}
